import React from 'react';
import './menuItem.scss';

export const MenuItem = (props) => {
  return (
    <li className="menuItem">
      <a href={props.link} className="menuUrl" onClick={() => props.onSelect()}>
        {props.itemName}
      </a>
    </li>
  );
};
